import React from 'react'
import styled from 'styled-components'

const StudentLinks = styled.ul`
  position:fixed;
  display:flex;
  list-style:none;
  padding:0 1em;
  bottom:0;
  width:100%;
  box-sizing:border-box;

  li{
    text-align:center;
    width:100%;
    a{
      /* background:blue; */
      /* display:block; */
      text-decoration:none;
      color:var(--light);
      font-size:var(--small-text);
      padding:0.5em;
      font-family: Arial, Helvetica, sans-serif;
      letter-spacing:0.06em;
    }

    &:first-child{
      text-align:left;
    }

    &:last-child{
      text-align:right;
    }
  }
`

export default function Links ({ links }) {
  return <StudentLinks>
    {links.map((link) => (

      <li key={link.key}>
        <a href={link.url}>
          {link.link_text}
        </a>
      </li>
    ))}
  </StudentLinks>
}
